import {ColorSchemeType} from 'platform/components';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getTireSetRequestStatus = (status: string | Nullish) => {
  const label = match(status)
    .with('REQUESTED', always(i18n.t('entity.tireSet.labels.requested')))
    .with('PREPARED', always(i18n.t('entity.tireSet.labels.prepared')))
    .with('DISPATCHED', always(i18n.t('entity.tireSet.labels.dispatched')))
    .with('CANCELLED', always(i18n.t('entity.tireSet.labels.cancelled')))
    .with('IN_TRANSIT', always(i18n.t('entity.tireSet.labels.inTransit')))
    .with('TRANSIT_ACCEPTANCE', always(i18n.t('entity.tireSet.labels.transitAcceptance')))
    .otherwise(always(undefined));

  const colorScheme = match<string | Nullish, ColorSchemeType | undefined>(status)
    .with('REQUESTED', always('yellow'))
    .with('PREPARED', always('green'))
    .with('IN_TRANSIT', always('orange'))
    .with('TRANSIT_ACCEPTANCE', always('blue'))
    .with('DISPATCHED', always('purple'))
    .with('CANCELLED', always('neutral'))
    .otherwise(always(undefined));

  return {label, colorScheme};
};
